var React = require('react');

function WatchLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.72 2.231l-1.333 4h15.226l-1.334-4H17.721zm16 4L31.952.921a1.01 1.01 0 00-.958-.69H17.007c-.434 0-.82.278-.958.69l-1.77 5.31H11a5 5 0 00-5 5v26a5 5 0 005 5h3.28l1.769 5.31c.137.412.524.69.958.69h13.986c.434 0 .82-.278.958-.69l1.77-5.31H37a5 5 0 005-5v-26a5 5 0 00-5-5h-3.28zm-2.107 36H16.387l1.334 4h12.558l1.334-4zM11 8.231a3 3 0 00-3 3v26a3 3 0 003 3h26a3 3 0 003-3v-26a3 3 0 00-3-3H11z"}));
}

WatchLight.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = WatchLight;

WatchLight.default = WatchLight;
